import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { GenericService } from '../../generic.service';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import { defaultLanguage } from '../../shared/constants/language.constants';
import { LandingService } from '../../landing-page/service/landing.service';
import { CrowdinService } from '../../shared/service/crowdin.service';

@Component({
    selector: 'app-account-info',
    imports: [CommonModule],
    templateUrl: './account-info.component.html',
    styleUrl: './account-info.component.scss'
})
export class AccountInfoComponent {
  deviceData: any = {};
  deviceData$: any = null;

  translations: { [key: string]: string } = {};
  currentLanguage: string = defaultLanguage;
  languageOptions: Array<{ value: string }> = [];
  isLoadingTranslations = true;
  subs = new Subscription();

  constructor(
    private router: Router,
    private genericService: GenericService,
    private crowdinService: CrowdinService,
    private landingService: LandingService,
  ) {
    this.deviceData$ = this.genericService.deviceData.subscribe((data) => {
      if (data) {
        this.deviceData = data;
      }
    });
  }

  ngOnInit() {
    this.languageOptions = this.landingService.getLanguageOptions();

    const stored = localStorage.getItem('deviceData');
    const selectedName = stored
      ? JSON.parse(stored).languageSelected || defaultLanguage
      : defaultLanguage;
    this.currentLanguage = selectedName;

    this.subs.add(
      this.landingService.languageName$.subscribe((langName) => {
        this.currentLanguage = langName;
        this.translations = this.crowdinService.getAllTranslations();
      }),
    );

    this.landingService.loadTranslations(this.currentLanguage);
    this.deviceData = this.genericService.deviceData.getValue();
  }

  async languageChange(event: any) {
    const selectedLang = event.target.value;
    await this.landingService.loadTranslations(selectedLang);
  }

  goBack() {
    history.go(-1);
  }
}
